<template>
    <nav class="container flex items-center justify-between flex-wrap bg-blue-700 rounded-lg py-3 md:py-6 px-4 md:px-12 my-4 md:my-8 mx-auto">
        <div class="flex">
            <router-link to="/">
                <div class="flex items-center flex-shrink-0 text-white mr-6">
                    <!-- <svg class="fill-current h-8 w-8 mr-2" width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"/></svg> -->
                    <span class="font-semibold text-xl tracking-tight">Liquidity Flow</span>
                </div>
            </router-link>
            <router-link
                id="openApp"
                to="payments"
                class="inline-block text-sm px-4 py-2 leading-none border no-underline rounded text-white border-white hover:border-transparent hover:text-teal-500 hover:bg-white ">
                Open App
            </router-link>
        </div>
        <div class="block lg:hidden">
            <button  @click="toggle" id="menu" data-cy="buttonMenu" class="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
                <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
            </button>
        </div>
        <div :class="open ? 'inline': 'hidden'"  class="w-full block lg:flex lg:items-center lg:w-auto">
            <div v-if="uid === ''" class="text-sm">
                <router-link
                    to="/"
                    class="block mt-4 lg:inline-block no-underline lg:mt-0 text-blue-200 hover:text-white mr-4"
                >
                    About
                </router-link>
                <router-link
                    to="pricing"
                    class="block mt-4 lg:inline-block no-underline lg:mt-0 text-blue-200 hover:text-white mr-4"
                >
                    Pricing
                </router-link>
                <!-- <a href="#responsive-header" class="block mt-4 lg:inline-block no-underline lg:mt-0 text-blue-200 hover:text-white mr-4">
                    Pricing
                </a> -->
                <router-link
                    to="login"
                    class="block mt-4 lg:inline-block no-underline lg:mt-0 text-blue-200 hover:text-white mr-3"
                >
                    Login
                </router-link>
            </div>
            <div v-else>
                <a
                    @click="signOut"
                    href=""
                    id="logOut"
                    data-cy="logOut"
                    class="block mt-4 lg:inline-block no-underline lg:mt-0 text-blue-200 hover:text-white mr-3"
                >
                    Logout
                </a>
            </div>
        </div>
    </nav>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { mapFields } from 'vuex-map-fields';

export default {
    name: 'Navigation',
    data() {
        return {
            open: false,
        };
    },
    computed: {
        ...mapFields([
            'user.uid',
        ]),
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        signOut(e) {
            e.stopPropagation();
            firebase.auth().signOut();
            this.$router.push({
                name: 'Login',
            });
        },
    },
};
</script>

<style>

</style>
